import React, { useEffect, useState } from "react";
import Header from "../header/Header";
// import SideBar from "../sidebar/SideBar";
import OrderShipmentHeader from "./OrderHistoryHeader";
import DashboardLayout from "../layout";
import { Dropdown, Menu, Modal, Space, message } from "antd";
import { useMutation, useQuery } from "@tanstack/react-query";
import { getCompletedShipments, getQuotes } from "../../lib/quotes";
import { deleteDoc, doc, serverTimestamp, updateDoc, getDoc } from "firebase/firestore";
import { db } from "../../config/firebase";
import { toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";
import { FormatDate } from "../../lib/dateFormat";
import { BiDotsVerticalRounded } from "react-icons/bi";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { Table } from "antd";
import InvoicePDF from "../shared/pdf/invoicePDF";
import { getUser } from "../../lib/user";
import dayjs from "dayjs";
import { api } from "../../config/api";
import InvoiceModal from "../shared/common/invoiceModal";
import Loader from "../shared/loader/loader";
import { useMyContext } from "../../context/MyContext";
import { Archive, CheckCircle, ChevronDown, Clock, FileText, Loader2, MapPin, Package, Plane, Truck, Warehouse } from "lucide-react";

const deliveryStatusOptions = [
  { value: "preparing collection", label: "Preparing Collection", icon: Clock },
  { value: "In delivery", label: "In Delivery", icon: Truck },
  { value: "Transit air", label: "Transit Air", icon: Plane },
  { value: "Compliance", label: "Compliance", icon: FileText },
  { value: "Storage", label: "Storage", icon: Archive },
  { value: "Delivered", label: "Delivered", icon: CheckCircle },
  { value: "Final delivery", label: "Final Delivery", icon: MapPin },
  { value: "completed", label: "Completed", icon: CheckCircle },
  { value: "warehouse shipment", label: "Warehouse Shipment", icon: Warehouse },
];


const StatusDropdown = ({ status, onChange, id, loading }) => {
  const [isOpen, setIsOpen] = useState(false);


  const getStatusColor = (statusValue) => {
    const lower = statusValue?.toLowerCase();
    switch (lower) {
      case "in progress":
      case "preparing collection":
        return {
          backgroundColor: '#f3f4f6',
          color: '#374151',
          borderColor: '#d1d5db'
        };
      case "delivered":
      case "completed":
        return {
          backgroundColor: '#dcfce7',
          color: '#166534',
          borderColor: '#86efac'
        };
      case "in delivery":
      case "transit air":
      case "compliance":
      case "warehouse shipment":
      case "storage":
      case "final delivery":
        return {
          backgroundColor: '#dbeafe',
          color: '#1e40af',
          borderColor: '#93c5fd'
        };
      default:
        return {
          backgroundColor: '#f3f4f6',
          color: '#374151',
          borderColor: '#d1d5db'
        };
    }
  };

  const isLoading = loading === id

  const currentStatus = deliveryStatusOptions.find(
    opt => opt.value.toLowerCase() === status?.toLowerCase()
  );
  const CurrentIcon = isLoading ? Loader2 : currentStatus?.icon || Package;

  const statusColors = getStatusColor(status);

  return (
    <div className="relative w-full max-w-xs">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-full px-3 py-2 rounded-lg border-2 transition-all duration-200 flex items-center justify-between gap-2 hover:shadow-md"
        style={{
          backgroundColor: isLoading ? "#fef3c7" : statusColors.backgroundColor,
          color: isLoading ? "#d97706" : statusColors.color,
          borderColor: isLoading ? "#d97706" : statusColors.borderColor
        }}
      >
        <div className="flex items-center gap-2">
          <CurrentIcon className={`${isLoading && 'animate-spin'}`} style={{ width: '16px', height: '16px' }} />
          <span className="text-sm font-medium capitalize truncate">
            {isLoading ? 'Please wait...' : status ? status : "Select Status"}
          </span>
        </div>
        <ChevronDown
          style={{
            width: '16px',
            height: '16px',
            transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
            transition: 'transform 200ms'
          }}
        />
      </button>

      {isOpen && (
        <>
          <div
            className="fixed inset-0 z-10"
            onClick={() => setIsOpen(false)}
          />
          <div className="absolute z-20 min-w-[250px] mt-2 bg-white rounded-lg shadow-xl border border-gray-200 max-h-80 overflow-y-auto">
            {deliveryStatusOptions.map((option) => {
              const Icon = option.icon;
              const isSelected = option.value.toLowerCase() === status?.toLowerCase();

              return (
                <button
                  key={option.value}
                  onClick={() => {
                    onChange(id, option.value);
                    setIsOpen(false);
                  }}
                  className={`w-full px-4 py-3 flex items-center gap-3 hover:bg-gray-50 transition-colors 
                    } ${option === deliveryStatusOptions[0] ? 'rounded-t-lg' : ''} ${option === deliveryStatusOptions[deliveryStatusOptions.length - 1] ? 'rounded-b-lg' : ''
                    }`}
                  style={{ backgroundColor: isSelected && '#dbeafe', color: isSelected && '#2563eb' }}
                >
                  {/* <Icon className={`w-4 h-4 ${isSelected ? 'text-blue-600' : 'text-gray-500'}`} /> */}
                  <Icon size={20} />
                  <span className={`text-sm font-medium whitespace-nowrap ${isSelected ? 'text-blue-600' : 'text-gray-700'}`}>
                    {option.label}
                  </span>
                  {isSelected && (
                    <CheckCircle className="w-4 h-4 ml-auto text-blue-600" />
                  )}
                </button>
              );
            })}
          </div>
        </>
      )}
    </div>
  );
};


const obj = {
  active: true, // Corrected the spelling of "active"
  content: "Order History",
};

const Index = () => {
  const navigate = useNavigate();
  const { token } = useMyContext();

  const [menuVisible, setMenuVisible] = useState(false);
  const [showDeleteConfirmationModal, setShowDeleteConfirmationModal] = useState(false);
  const [selectId, setSelectId] = useState('');
  const [filteredData, setFilteredData] = useState([]);
  const [completedData, setCompletedData] = useState([]);
  const [delModal, setDelModal] = useState(false);

  const [invoiceModalOpen, setInvoiceModalOpen] = useState(false);
  const [invoiceLoading, setInvoiceLoading] = useState(false);
  const [shipmentData, setShipmentData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [dataFetched, setDataFetched] = useState(false);
  const [loadingId, setLoadingId] = useState(null);

  useEffect(() => {
    const closeMenuOnOutsideClick = (event) => {
      if (menuVisible) {
        const dropdownContainer = document.querySelector(".ant-dropdown");
        if (dropdownContainer && !dropdownContainer.contains(event.target)) {
          setMenuVisible(false);
        }
      }
    };

    document.body.addEventListener("click", closeMenuOnOutsideClick);

    return () => {
      document.body.removeEventListener("click", closeMenuOnOutsideClick);
    };
  }, [menuVisible]);
  const { data: invoices } = useQuery(
    ["invoices"],
    async () => {
      if (!token) {
        throw new Error("No authentication token available");
      }
      const res = await api.get("/invoice", {
        headers: {
          Authorization: `Bearer ${token}` // Include the token in the request headers
        }
      });
      return res.data;
    },
    {
      refetchOnWindowFocus: false,
      enabled: !!token, // Only run the query if the token is available
    }
  );

  // const { data, refetch } = useQuery(
  //   ["quotes"],
  //   async () => {
  //     const res = await getCompletedShipments();
  //     return res;
  //   },
  //   {
  //     refetchOnWindowFocus: false,
  //   }
  // );

  const { data, refetch, isLoading, error } = useQuery(
    ["completed-shipments"], // Use a more specific query key
    async () => {
      const res = await getCompletedShipments();
      return res;
    },
    {
      refetchOnWindowFocus: false,
      staleTime: 60000, // Data stays fresh for 1 minute
      cacheTime: 300000, // Cache persists for 5 minutes
      onError: (error) => {
        console.error("Error fetching data:", error);
        setFilteredData([]);
      }
    }
  );
  useEffect(() => {
    if (data) {
      const completedData = data.filter(item => item.status === "completed");
      setCompletedData(completedData);
      setFilteredData(completedData);
      setDataFetched(true); // Mark data as fetched
    }
  }, [data]);


  const handleMenuClick = ({ key }) => {
    if (key === 'edit') {
      // Handle the edit action
    } else if (key === 'delete') {

    }
    setMenuVisible(false);
  };

  const deleteMutation = useMutation(
    async (selectId) => {
      try {
        const userRef = doc(db, "quotes", selectId);
        await deleteDoc(userRef);
        setShowDeleteConfirmationModal(false);
        refetch();
      } catch (error) {
        console.error("Error deleting quotes", error);
        if (error.code === "not-found") {
          toast.warning("User not found");
        } else {
          toast.error(`Could not delete quotes: ${error.message}`);
        }
      }
    },
    {
      onSuccess: () => {
        message.success("Quotes deleted successfully!");
      },
    }
  );


  const deliveryStatusOptions = [
    "preparing collection",
    "In delivery",
    "Transit air",
    "Compliance",
    "Storage",
    "Delivered",
    "Final delivery",
    "completed",
    "warehouse shipment",
  ];


  const getStatusStyles = (status) => {
    // console.log("status", status);
    switch (status?.toLowerCase()) {
      case "in progress":
        return { borderColor: "#FFC93F", backgroundColor: "#FFC93F" };
      case "delivered":
        return { borderColor: "#7CE13E", backgroundColor: "#7CE13E" };
      case "canceled":
        return { borderColor: "#FF4A3F", backgroundColor: "#FF4A3F" };
      case "preparing collection":
        return { borderColor: "#FFC93F", backgroundColor: "#FFC93F" };
      case "in delivery":
        return { borderColor: "#6A8EC8", backgroundColor: "#6A8EC8" };
      case "transit air":
        return { borderColor: "#FF4A3F", backgroundColor: "#FF4A3F" };
      case "compliance":
        return { borderColor: "#8D75C3", backgroundColor: "#8D75C3" };
      case "warehouse shipment":
        return { borderColor: "#A0673D", backgroundColor: "#A0673D" };
      case "storage":
        return { borderColor: "#7460F1", backgroundColor: "#7460F1" };
      case "final delivery":
        return { borderColor: "green", backgroundColor: "green" };
      case "completed":
        return { borderColor: "green", backgroundColor: "green" };
      default:
        return { borderColor: "#000", backgroundColor: "#fff" }; // Default styles
    }
  };
  // Define the updateStatus function
  const handleStatusChange = async (id, newStatus) => {
    setLoadingId(id);
    try {
      const userDocRef = doc(db, "quotes", id);
      const quoteSnapshot = await getDoc(userDocRef);
      const quoteData = quoteSnapshot.data();
      if (newStatus?.toLowerCase() === "warehouse shipment") {
        await updateDoc(userDocRef, {
          status: newStatus,
          sinceInWarehouse: serverTimestamp(),
        });
      } else {
        await updateDoc(userDocRef, { status: newStatus });
      }
      await api.post("/notifications", {
        title: "Shipment Status Updated",
        message: `Status of '${quoteData.orderNumber}' Shipment changed to '${newStatus}'`,
        linkText: "View Shipment",
        link: `/shipments?ship=${id}`,
        role: "user",
        userId: quoteData.userId,
        quoteNumber: quoteData.quoteNumber,
        type: "shipment-status-update"
      });

      toast.success("Quote status updated successfully!");
      refetch();
      // Optionally, you can avoid full page reload and update the quote status in your local state
      // by updating the quote object with the new status.
    } catch (error) {
      console.error("Error updating status:", error);
      toast.error("Error updating status. Please try again later.");
    } finally {
      setLoadingId(null);
    }
  };


  const openInvoiceModal = async (data) => {
    setShipmentData(data);
    setInvoiceModalOpen(true);
  };

  const showActionWarning = ({ title, content, okText, okType = "primary", onOk }) => {
    Modal.confirm({
      title,
      icon: <ExclamationCircleOutlined />,
      content,
      okText,
      cancelText: "Cancel",
      okType,
      onOk,
    });
  };

  const handleDownloadInvoice = async (record) => {
    setInvoiceLoading(true);
    try {
      const res = await api.get(`/invoice/shipment/${record?.id}`);
      const invoiceData = res.data;
      const invoiceDate = dayjs(invoiceData?.invoiceDate);
      const dueDate = dayjs(invoiceData?.dueDate);
      const paymentWithin = dueDate.diff(invoiceDate, "day");
      let client;

      try {
        client = await getUser(record?.userId);
      } catch (error) {
        console.warn("Linked user not found for invoice download:", record?.userId, error);
        toast.warning("Linked user not found. Downloading invoice with shipment details.");
        client = {
          name: record?.name || "Unknown Client",
          address: record?.address || "",
          postalCode: record?.postalCode || "",
          city: record?.city || "",
          country: record?.country || "",
          vatNumber: record?.vatNumber || "",
        };
      }

      let discount = null;
      if (invoiceData && Object.prototype.hasOwnProperty.call(invoiceData, 'discount')) {
        discount = invoiceData.discount;
      } else if (invoiceData?.discount !== undefined) {
        discount = invoiceData.discount;
      } else {
        discount = record?.discount || record?.tradeOSData?.discount || null;
      }
      const dataToSend = {
        ...invoiceData,
        discount,
        paymentWithin,
        client,
        shipment: {
          ...record,
          discount,
        },
      };

      const blob = await InvoicePDF(dataToSend);
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = `Invoice_${dataToSend?.invoiceNo}.pdf`;
      link.click();
    } catch (error) {
      console.error("Error generating invoice:", error);
      toast.error("Invoice not downloaded");
    } finally {
      setInvoiceLoading(false);
    }
  };

  const columns = [
    {
      title: "Order Date",
      dataIndex: "creationDate",
      render: (creationDate) => FormatDate(creationDate), // Apply FormatDate function to render the date
      sorter: {
        compare: (a, b) => new Date(a.creationDate) - new Date(b.creationDate),
        multiple: 1
      },
      defaultSortOrder: 'decending'
    },
    {
      title: "Order Number",
      dataIndex: "orderNumber",
    },
    {
      title: "Quote Number",
      dataIndex: "quoteNumber",
    },
    {
      title: "Name",
      dataIndex: "name",
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (status, record) => (
        <td className="p-1">
          {/* <select
            className={`border capitalize rounded-sm text-white p-1 py-1  bg-[#e5edfb] w-48`}
            style={{
              ...getStatusStyles(status),
            }}
            value={status}
            onChange={(e) => handleStatusChange(record.id, e.target.value)}
          >
            <option value="" disabled className="text-black bg-white">
              Select Delivery Status
            </option>
            {deliveryStatusOptions.map((status, index) => (
              <option key={index} value={status} className="text-black bg-white">
                {status}
              </option>
            ))}
          </select> */}
          <StatusDropdown
            status={status}
            onChange={(id, value) => handleStatusChange(id, value)}
            id={record.id}
            loading={loadingId}
          />
        </td>
      ),
    },
    {
      title: "Load Address",
      dataIndex: "loadAddress", // Assuming you have a single field for load address
      render: (loadAddress, record) => `${record.loadCountry}, ${record.loadCity}`, // Combine loadCountry and loadCity
    },
    {
      title: "Unload Address",
      dataIndex: "unloadAddress", // Assuming you have a single field for unload address
      render: (unloadAddress, record) => `${record.unloadCountry}, ${record.unloadCity}`, // Combine unloadCountry and unloadCity
    },
    {
      title: "Actions",
      render: (_, record) => (
        <Dropdown
          overlay={
            <Menu>
              <Menu.Item
                key="1"
                onClick={() =>
                  showActionWarning({
                    title: "Edit Shipment?",
                    content: "This shipment is already in Order History. Editing it may change saved order details. Do you want to continue?",
                    okText: "Continue",
                    onOk: () => navigate(`/shipments/${record?.id}`),
                  })
                }
              >
                Edit
              </Menu.Item>
              <Menu.Item
                key="2"
                onClick={() =>
                  showActionWarning({
                    title: "Delete Shipment?",
                    content: "Are you sure you want to delete the selected shipment? This action cannot be undone.",
                    okText: "Delete",
                    okType: "danger",
                    onOk: () => deleteMutation.mutate(record.id),
                  })
                }
              >
                Delete
              </Menu.Item>
              <Menu.Item
                key="3"
                onClick={() => openInvoiceModal(record)}
              >
                <Space>Create Invoice</Space>
              </Menu.Item>
              {invoices?.find((e) => e?.shipmentId === record?.id) ? (
                <Menu.Item
                  onClick={() => handleDownloadInvoice(record)}
                  key="download invoice"
                >
                  <Space>
                    {invoiceLoading ? "Downloading..." : "Download Invoice"}
                  </Space>
                </Menu.Item>
              ) : null}

            </Menu>
          }
          placement="bottomRight"
        >
          <div className="border-2 w-fit rounded-md p-1">
            <BiDotsVerticalRounded className="cursor-pointer" size={20} />
          </div>
        </Dropdown>
      ),
    },
  ];

  const tableSection = () => {
    if (!dataFetched) {
      return <Loader />;
    }

    if (!Array.isArray(filteredData)) {
      return <div className="text-center text-gray-500 py-10">Error loading data</div>;
    }

    if (dataFetched && filteredData.length === 0) {
      return (
        <div className="text-center text-gray-500 py-10">
          No matching results found
        </div>
      );
    }

    return (
      <Table
        columns={columns}
        dataSource={filteredData}
        size="small"
        className="table w-full border-0"
      />
    );
  };


  return (
    <>
      <DashboardLayout>
        <div className="w-full bg-cus-gray h-full">
          <Header title="Order History" />
          <div className='p-5 bg-[hsl(215,40%,94%)]'>
            <OrderShipmentHeader
              filteredData={filteredData}
              setFilteredData={setFilteredData}
              Data={completedData}
            />
            <div className="bg-white rounded-md md:py-5 py-3 px-0 flex items-center mt-4 justify-between w-full">
              <div className="w-full">
                {tableSection()}
              </div>
            </div>
          </div>
        </div>
      </DashboardLayout>

      {/* Keep all the existing modals */}
      <Modal
        title="Confirm Deletion"
        open={showDeleteConfirmationModal}
        onCancel={() => setShowDeleteConfirmationModal(false)}
        onOk={() => deleteMutation.mutate(selectId)}
        okText="Yes"
        cancelText="No"
        okButtonProps={{
          style: { backgroundColor: "#D83535", color: "#FFFFFF" },
        }}
      >
        <p>Are you sure you want to delete the selected shipment?</p>
      </Modal>

      {invoiceModalOpen && (
        <InvoiceModal
          setModalOpen={setInvoiceModalOpen}
          modalOpen={invoiceModalOpen}
          shipmentData={shipmentData}
          setShipmentData={setShipmentData}
        />
      )}
    </>
  );
};

export default Index;
